var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "card-title mb-4" }, [_vm._v("\n    Account\n  ")]),
    _c("h4", { staticClass: "card-subtitle" }, [_vm._v("Profile")]),
    _c(
      "form",
      {
        attrs: { action: "/proxy/users/me", method: "post" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            _vm.update($event)
          }
        }
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "_method", value: "patch" }
        }),
        _c("div", { staticClass: "form-group row" }, [
          _c(
            "label",
            {
              staticClass: "col-form-label col-sm-12 col-md-3",
              attrs: { for: "name" }
            },
            [_vm._v("\n        Name\n      ")]
          ),
          _c("div", { staticClass: "col-sm-12 col-md-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "name", name: "name" },
              domProps: { value: _vm.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "form-group row" }, [
          _c(
            "label",
            {
              staticClass: "col-form-label col-sm-12 col-md-3",
              attrs: { for: "description" }
            },
            [_vm._v("\n        Description\n      ")]
          ),
          _c("div", { staticClass: "col-sm-12 col-md-9" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.description,
                  expression: "description"
                }
              ],
              staticClass: "form-control",
              attrs: {
                name: "description[text]",
                cols: "30",
                rows: "7",
                id: "description"
              },
              domProps: { value: _vm.description },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.description = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "form-group row" }, [
          _c(
            "div",
            { staticClass: "ml-md-auto col-md-9" },
            [_c("submit-button")],
            1
          )
        ])
      ]
    ),
    false
      ? _c("div", [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _c("div", { staticClass: "col-sm-12 col-md-9" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: _vm.cover.link,
                    width: _vm.cover.width,
                    height: _vm.cover.height,
                    alt: "cover image"
                  }
                })
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  ref: "coverFileInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", accept: "image/*" },
                  on: { change: _vm.coverChanged }
                }),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary mr-2",
                    attrs: { type: "button" },
                    on: { click: _vm.changeCover }
                  },
                  [_vm._v("\n            Change cover\n          ")]
                ),
                _vm._v("\n          " + _vm._s(_vm.coverMessage) + "\n        ")
              ])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _vm._m(1),
            _c("div", { staticClass: "col-ms-12 col-md-9" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("img", {
                  attrs: {
                    src: _vm.avatar.link,
                    width: "128",
                    height: "128",
                    alt: "avatar image"
                  }
                })
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  ref: "avatarFileInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", accept: "image/*" },
                  on: { change: _vm.avatarChanged }
                }),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary mr-2",
                    attrs: { type: "button" },
                    on: { click: _vm.changeAvatar }
                  },
                  [_vm._v("\n            Change avatar\n          ")]
                ),
                _vm._v(
                  "\n          " + _vm._s(_vm.avatarMessage) + "\n        "
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12 col-md-3" }, [
      _c("h4", [_vm._v("Cover")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12 col-md-3" }, [
      _c("h4", [_vm._v("Avatar")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dacf0dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dacf0dc","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/settings/Account.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1dacf0dc","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/settings/Account.vue
// module chunks = 14